var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Right Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4222 20C4.99693 20 0.597656 15.5233 0.597656 10C0.597656 4.47779 4.99688 0 10.4222 0C15.8475 0 20.2468 4.47779 20.2468 10C20.2468 15.5233 15.8475 20 10.4222 20ZM2.07134 10C2.07134 14.6947 5.81072 18.5 10.4222 18.5C15.0337 18.5 18.7731 14.6947 18.7731 10C18.7731 5.30621 15.0336 1.5 10.4222 1.5C5.81077 1.5 2.07134 5.30621 2.07134 10Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48422 13.9999C8.19709 13.7064 8.1981 13.2315 8.48647 12.9392L11.3869 9.9997L8.48647 7.06018C8.1981 6.76791 8.19709 6.29304 8.48422 5.99952C8.77136 5.70599 9.2379 5.70497 9.52627 5.99723L12.9511 9.46823C13.09 9.60897 13.1681 9.80023 13.1681 9.9997C13.1681 10.1992 13.09 10.3904 12.9511 10.5312L9.52627 14.0022C9.2379 14.2944 8.77136 14.2934 8.48422 13.9999Z",
    fill: "#221AFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow_right_circle.4f32912b202ec85605b43fd0cde732e3.svg";
export { ForwardRef as ReactComponent };